import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f1424372"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "buttonLabel"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "buttonLabel"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "buttonLabel"
}

import { computed, ComputedRef, Slots, useSlots } from 'vue';
import { RouteLocationRaw } from 'vue-router';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { isSlotPopulated } from '@/data/helpers/ComponentHelper';

interface Props {
  icon?: string;
  label?: string;
  tag?: string;
  to?: RouteLocationRaw;
  disabled?: boolean;
  isButton?: boolean;
  iconOnLeft?: boolean;
}
interface Emits {
  (e: 'click', event: Event): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    icon: {},
    label: {},
    tag: { default: 'button' },
    to: {},
    disabled: { type: Boolean, default: false },
    isButton: { type: Boolean, default: true },
    iconOnLeft: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots: Slots = useSlots();

const classes: ComputedRef<string> = computed(() => {
  const classes: string[] = ['button', 'primary'];
  if (!props.iconOnLeft) {
    classes.push('rev');
  }
  if (!props.label) {
    if (!isSlotPopulated(slots.default)) {
      classes.push('iconOnly');
    }
  }
  return classes.join(' ');
});

const toObject: ComputedRef<RouteLocationRaw> = computed(() => {
  return props.to ? props.to : {};
});

function clicked(event: MouseEvent): void {
  if (!props.disabled) {
    emit('click', event);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: toObject.value,
        tag: _ctx.tag,
        class: _normalizeClass(classes.value),
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(BrandIcon, {
                key: 0,
                class: "icon",
                name: _ctx.icon
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          (!_ctx.label)
            ? _renderSlot(_ctx.$slots, "default", { key: 2 })
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 3
      }, 8, ["to", "tag", "class", "disabled"]))
    : (_ctx.isButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(classes.value),
          onClick: clicked,
          disabled: _ctx.disabled
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(BrandIcon, {
                key: 0,
                class: "icon",
                name: _ctx.icon
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          (!_ctx.label)
            ? _renderSlot(_ctx.$slots, "default", { key: 2 })
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "button primary rev",
          onClick: clicked,
          disabled: _ctx.disabled
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(BrandIcon, {
                key: 0,
                class: _normalizeClass(classes.value),
                name: _ctx.icon
              }, null, 8, ["class", "name"]))
            : _createCommentVNode("", true),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          (!_ctx.label)
            ? _renderSlot(_ctx.$slots, "default", { key: 2 })
            : _createCommentVNode("", true)
        ], 8, _hoisted_4))
}
}

})